import { CampaignState, MessageMedium } from 'modules/domains/campaign';
import { CampaignEditorHeader, SendProgressBar } from './components';
import { PrimaryContent } from './components/PrimaryContent/PrimaryContent';
import { getIsBlastCampaign } from './components/Sections/utils';
import { SuspendSendsBanner } from './components/SuspendSendsBanner';
import { TemplateContent } from './components/TemplateContent/TemplateContent';
import { WhatsAppWarningBanner } from './components/WhatsAppWarningBanner';
import {
  useCampaignContext,
  useEditorContext,
  useFeatureFlagContext,
  useTemplateContext,
} from './context';
import { useWhatsAppWarnings } from './hooks';
import { CampaignEditorBody, CampaignEditorContainer, WarningBannerContainer } from './styles';
import { CampaignEditorView } from './types';

export const CampaignEditorStep = () => {
  const { campaign } = useCampaignContext();
  const { campaignEditorView } = useEditorContext();
  const { isSuspendSendsEnabled } = useFeatureFlagContext();
  const { templateAndContent } = useTemplateContext();
  const warnings = useWhatsAppWarnings(
    campaign?.templateId,
    campaign?.messageMedium,
    templateAndContent?.templateType,
  );
  /**
   * @see https://github.com/Iterable/iterable/blob/2d314199f5556a0173bd158a44d7836d183e3cd5/app/views/partials/campaigns/campaignSummaryAndActions.scala.html#L95
   */
  const shouldShowSendProgressBar =
    getIsBlastCampaign(campaign?.campaignTypeDefinition) &&
    campaign?.messageMedium !== MessageMedium.InApp &&
    [CampaignState.Running].includes(campaign?.campaignState);

  return (
    <CampaignEditorContainer>
      <CampaignEditorHeader />

      {isSuspendSendsEnabled && campaignEditorView === CampaignEditorView.Summary && (
        <SuspendSendsBanner />
      )}
      {!!warnings.length && (
        <WarningBannerContainer>
          <WhatsAppWarningBanner warnings={warnings} />
        </WarningBannerContainer>
      )}
      {shouldShowSendProgressBar && <SendProgressBar />}

      <CampaignEditorBody>
        <PrimaryContent />
        <TemplateContent />
      </CampaignEditorBody>
    </CampaignEditorContainer>
  );
};
